<div class="flex-parent">
    <div class="login-form-div">
        <mat-icon class="really-big-icon icon-red pulse-icon" >lock</mat-icon>
        <div class="header">
            <h3 class="text-details">
                {{'accessDenied.message' | translate}}
            </h3>
        </div>
        <div class="additional-options">
            <app-back-button></app-back-button>
            <app-back-button [logout]="true"></app-back-button>
        </div>
    </div>
</div>
